<template>
  <div>
    <!-- begin::Sticky Toolbar -->
    <ul class="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 mt-4"
        :style="linkShow==1?'width: 15rem;align-items: inherit;':''">
      <li class="nav-item pb-3">
        <div class="row align-items-center" v-if="linkShow==1">
          <div class="col-xl-12 text-right pt-2 pb-2">
            <button class="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger" v-on:click="hideLink">
              <i class="fa fa-times text-danger"></i>
            </button>
          </div>
        </div>
        <div class="row align-items-center" v-if="linkShow==2">
          <div class="col-xl-12">
            <button class="btn btn-sm btn-icon btn-bg-light btn-text-warning btn-hover-warning" v-on:click="openLink">
              <span style="word-break: break-all;">{{$t('BOTTOM.Contact_Platform')}}</span>
            </button>
          </div>
        </div>
      </li>
      <li class="nav-item pt-3" v-if="linkShow==1 && manageUserList">
        <template v-for="item in manageUserList">
          <div class="row border-top pl-3 pr-3" :key="item.recordId">
            <div class="col-xl-12">
              <div class="align-items-center">
                <i class="flaticon2-user text-primary"></i>&nbsp;&nbsp;&nbsp;
                <span v-if="activeLanguage == 'en'">
                  {{item.englishContent}}
                  ({{item.eName}})
                </span>
                <span v-if="activeLanguage == 'ch'">
                  {{item.chineseContent}}
                  ({{item.userName}})
                </span>
              </div>
              <div class="align-items-center">
                <i class="flaticon2-email text-primary"></i>&nbsp;&nbsp;&nbsp;{{item.email}}
              </div>
              <div class="align-items-center">
                <i class="flaticon2-phone text-primary"></i>&nbsp;&nbsp;&nbsp;(+86){{item.phone}}
              </div>
            </div>
          </div>
        </template>
      </li>
    </ul>
    <!-- end::Sticky Toolbar -->
  </div>
</template>
<script>
import i18nService from "@/core/services/i18n.service";
export default {
  name: "KTStickyToolbar",
  data() {
    return {
      manageUserList: [],
      linkShow: "2",
    };
  },
  mounted() {
    this.openManageUserList();
  },
  computed: {
    user: {
      get () {
        return this.$store.getters.currentUser;
      }
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  },
  methods: {
    openManageUserList() {
      this.linkShow = window.localStorage.getItem("linkShow");
      if (!this.linkShow){
        this.linkShow = "2";
      }
      if (this.user && this.user.icloudUserList){
        this.manageUserList = this.user.icloudUserList;
      }else {
        this.$axios.fetchPost("hr/user/getManageUserList").then(result => {
          this.manageUserList = result.data;
        }).catch(err => {alert(err)});
      }
    },
    hideLink() {
      this.linkShow = "2";
      window.localStorage.setItem("linkShow", this.linkShow);
    },
    openLink() {
      this.linkShow = "1";
      window.localStorage.setItem("linkShow", this.linkShow);
    },
  },
}
</script>
